import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "places-dtm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcButton = _resolveComponent("NcButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "place-btn",
        key: place.cluster_id
      }, [
        _createVNode(_component_NcButton, {
          class: "place",
          to: _ctx.route(place)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(place.name), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}